import './sentry'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import App from './App'
import { AuthProvider } from '@/contexts/AuthContext'
import { ToastProvider } from '@/contexts/ToastContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { queryClient } from '@/lib/queryClient'
import { asyncStoragePersister, shouldDehydrateQuery } from '@/lib/queryPersister'
import { registerAdapter } from '@/adapters/registry'
import { blueskyAdapter } from '@/adapters/blueskyAdapter'
import { mastodonAdapter } from '@/adapters/mastodonAdapter'
import { pixelfedAdapter } from '@/adapters/pixelfedAdapter'
import { nostrAdapter } from '@/adapters/nostrAdapter'
import './index.css'

// Register protocol adapters at startup
registerAdapter(blueskyAdapter)
registerAdapter(mastodonAdapter)
registerAdapter(pixelfedAdapter)
registerAdapter(nostrAdapter)

// In dev mode, unregister any stale service workers from previous production builds
// that would otherwise serve cached old JS on normal reloads.
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
    void navigator.serviceWorker.getRegistrations().then(registrations => {
        for (const registration of registrations) {
            void registration.unregister()
        }
    })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <PersistQueryClientProvider
                client={queryClient}
                persistOptions={{
                    persister: asyncStoragePersister,
                    dehydrateOptions: { shouldDehydrateQuery },
                    buster: 'v2', // v2: account-scoped Mastodon keys (#2458)
                }}
            >
                <ThemeProvider>
                    <AuthProvider>
                        <ToastProvider>
                            <App />
                        </ToastProvider>
                    </AuthProvider>
                </ThemeProvider>
            </PersistQueryClientProvider>
        </BrowserRouter>
    </React.StrictMode>
)
